(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["group-workshops-quote"] && !Shopify.designMode) return;
  try {
    
  /* Show the weekday hint when any preferred date falls on a weekend */
  document.querySelectorAll('[data-gw-dates]').forEach((group) => {
    const hint = group.querySelector('[data-gw-weekend-hint]');
    if (!hint) return;
    const inputs = group.querySelectorAll('input[type="date"]');
    const update = () => {
      hint.hidden = !Array.from(inputs).some((input) => {
        if (!input.value) return false;
        const day = new Date(`${input.value}T12:00:00`).getDay();
        return day === 0 || day === 6;
      });
    };
    inputs.forEach((input) => input.addEventListener('change', update));
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
